export default "__VITE_ASSET__Bqc$hDZr__"